/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TaskBoxPersonResponse } from './TaskBoxPersonResponse';
import {
    TaskBoxPersonResponseFromJSON,
    TaskBoxPersonResponseFromJSONTyped,
    TaskBoxPersonResponseToJSON,
    TaskBoxPersonResponseToJSONTyped,
} from './TaskBoxPersonResponse';

/**
 * 
 * @export
 * @interface TaskBoxesResponse
 */
export interface TaskBoxesResponse {
    /**
     * 
     * @type {string}
     * @memberof TaskBoxesResponse
     */
    taskBoxId?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskBoxesResponse
     */
    taskBoxTitle?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TaskBoxesResponse
     */
    isAssignee?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TaskBoxesResponse
     */
    isCreator?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TaskBoxesResponse
     */
    isFavorite?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TaskBoxesResponse
     */
    totalTask?: number;
    /**
     * 
     * @type {string}
     * @memberof TaskBoxesResponse
     */
    taskBoxChannelType?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskBoxesResponse
     */
    taskBoxModuleType?: string;
    /**
     * 
     * @type {TaskBoxPersonResponse}
     * @memberof TaskBoxesResponse
     */
    pwrTaskBoxCreator?: TaskBoxPersonResponse;
    /**
     * 
     * @type {Array<TaskBoxPersonResponse>}
     * @memberof TaskBoxesResponse
     */
    pwrParticipants?: Array<TaskBoxPersonResponse>;
}

/**
 * Check if a given object implements the TaskBoxesResponse interface.
 */
export function instanceOfTaskBoxesResponse(value: object): value is TaskBoxesResponse {
    return true;
}

export function TaskBoxesResponseFromJSON(json: any): TaskBoxesResponse {
    return TaskBoxesResponseFromJSONTyped(json, false);
}

export function TaskBoxesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskBoxesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'taskBoxId': json['taskBoxId'] == null ? undefined : json['taskBoxId'],
        'taskBoxTitle': json['taskBoxTitle'] == null ? undefined : json['taskBoxTitle'],
        'isAssignee': json['isAssignee'] == null ? undefined : json['isAssignee'],
        'isCreator': json['isCreator'] == null ? undefined : json['isCreator'],
        'isFavorite': json['isFavorite'] == null ? undefined : json['isFavorite'],
        'totalTask': json['totalTask'] == null ? undefined : json['totalTask'],
        'taskBoxChannelType': json['taskBoxChannelType'] == null ? undefined : json['taskBoxChannelType'],
        'taskBoxModuleType': json['taskBoxModuleType'] == null ? undefined : json['taskBoxModuleType'],
        'pwrTaskBoxCreator': json['pwrTaskBoxCreator'] == null ? undefined : TaskBoxPersonResponseFromJSON(json['pwrTaskBoxCreator']),
        'pwrParticipants': json['pwrParticipants'] == null ? undefined : ((json['pwrParticipants'] as Array<any>).map(TaskBoxPersonResponseFromJSON)),
    };
}

export function TaskBoxesResponseToJSON(json: any): TaskBoxesResponse {
    return TaskBoxesResponseToJSONTyped(json, false);
}

export function TaskBoxesResponseToJSONTyped(value?: TaskBoxesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'taskBoxId': value['taskBoxId'],
        'taskBoxTitle': value['taskBoxTitle'],
        'isAssignee': value['isAssignee'],
        'isCreator': value['isCreator'],
        'isFavorite': value['isFavorite'],
        'totalTask': value['totalTask'],
        'taskBoxChannelType': value['taskBoxChannelType'],
        'taskBoxModuleType': value['taskBoxModuleType'],
        'pwrTaskBoxCreator': TaskBoxPersonResponseToJSON(value['pwrTaskBoxCreator']),
        'pwrParticipants': value['pwrParticipants'] == null ? undefined : ((value['pwrParticipants'] as Array<any>).map(TaskBoxPersonResponseToJSON)),
    };
}

